import { render, staticRenderFns } from "./EntityEdit.vue?vue&type=template&id=cb6b68cc&scoped=true"
import script from "./EntityEdit.vue?vue&type=script&lang=js"
export * from "./EntityEdit.vue?vue&type=script&lang=js"
import style0 from "./EntityEdit.vue?vue&type=style&index=0&id=cb6b68cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6b68cc",
  null
  
)

export default component.exports